import { client } from '../client';

export async function acceptCookies() {
    return client.POST('/cookie/accept', { body: {} });
}
